<template>
    <SelectorModal v-if="this.isMobile" v-model="toggleModal" @close-modal="closeModal">
        <template v-slot:title><strong>Envio imediato</strong></template>
        <div class="card-block">
            <div class="delivery-ready-section mobile">
                <div class="d-flex section-text" v-if="!selected.model_url || !selected.size">
                    <p>
                        Ative o filtro <strong>Envio Imediato</strong> par ver apenas os produtos em
                        estoque, com
                        <strong>menor prazo de envio.</strong>
                    </p>
                </div>
                <div v-if="!selected.model_url && selected.type_id === 1">
                    <p class="">Selecione uma modelagem para ativar o filtro:</p>
                    <div class="d-flex filter-wrapper-mobile">
                        <CatalogDeliveryReadyItem
                            v-for="model in filters.models"
                            :isMobile="isMobile"
                            :key="model.name"
                            :label="model.name"
                            :value="model.id"
                            :link="model.url"
                            class="model text-uppercase"
                            url-param="modelagem"
                        />
                    </div>
                </div>
                <div v-if="!selected.size && (selected.model_url || selected.type_id !== 1)">
                    <p>Selecione um tamanho para ativar o filtro:</p>
                    <div class="d-flex filter-wrapper-mobile">
                        <CatalogDeliveryReadyItem
                            v-if="filters.sizes_adult"
                            v-for="size in filters.sizes_adult"
                            :isMobile="isMobile"
                            :key="size.name"
                            :label="size.name"
                            :value="size.name"
                            :link="size.url"
                            class="size text-uppercase"
                            url-param="tamanho"
                        />
                        <CatalogDeliveryReadyItem
                            v-if="filters.sizes_child"
                            v-for="size in filters.sizes_child"
                            :isMobile="isMobile"
                            :key="size.name"
                            :label="size.name"
                            :value="size.name"
                            :link="size.url"
                            class="size text-uppercase"
                            url-param="tamanho"
                        />
                    </div>
                </div>
            </div>
        </div>
    </SelectorModal>
    <div v-else>
        <div
            class="d-flex"
            :style="{ flexDirection: 'column', gap: '8px' }"
            v-if="!selected.model_url && selected.type_id === 1"
        >
            <span class="text-uppercase">Selecione um modelo:</span>
            <div class="d-flex filter-wrapper">
                <CatalogDeliveryReadyItem
                    v-for="model in filters.models"
                    :isMobile="isMobile"
                    :key="model.name"
                    :label="model.name"
                    :value="model.id"
                    :link="model.url"
                    class="model text-uppercase"
                    url-param="modelagem"
                />
            </div>
        </div>
        <div
            class="d-flex"
            :style="{ flexDirection: 'column', gap: '8px' }"
            v-if="(selected.model_url || selected.type_id !== 1) && !selected.size"
        >
            <span class="text-uppercase">Selecione um tamanho:</span>
            <div class="d-flex filter-wrapper">
                <CatalogDeliveryReadyItem
                    v-if="filters.sizes_adult"
                    v-for="size in filters.sizes_adult"
                    :isMobile="isMobile"
                    :key="size.name"
                    :label="size.name"
                    :value="size.name"
                    :link="size.url"
                    class="size text-uppercase"
                    url-param="tamanho"
                />
                <CatalogDeliveryReadyItem
                    v-if="filters.sizes_child"
                    v-for="size in filters.sizes_child"
                    :isMobile="isMobile"
                    :key="size.name"
                    :label="size.name"
                    :value="size.name"
                    :link="size.url"
                    class="size text-uppercase"
                    url-param="tamanho"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import SelectorModal from '../common/SelectorModal';
    import CatalogDeliveryReadyItem from './CatalogDeliveryReadyItem';
    export default {
        name: 'CatalogDeliveryReady',
        components: {
            SelectorModal,
            CatalogDeliveryReadyItem,
        },
        props: {
            selected: {
                type: Object,
                required: true,
            },
            filters: {
                type: Object,
                required: true,
            },
            toggleModal: {
                type: Boolean,
            },
            checkSelections: {
                type: Boolean,
            },
            isMobile: Boolean,
        },

        watch: {
            selected() {
                if (this.checkSelections) {
                    this.closeModal();
                }
            },
        },

        methods: {
            closeModal() {
                this.$emit('close-modal');
            },
        },
    };
</script>
